




















import { defineComponent } from 'vue-demi';
import theme from '@zk/theme/lib/variables.scss';
import { useI18n } from 'common-module/src/util/useI18n';

export default defineComponent({
  name: 'RecorderExtensionInstallNoticeCard',
  bemNS: theme.bemNS,
  setup() {
    const { t } = useI18n();
    return {
      t,
      onInstalled: () => window.open('https://chrome.google.com/webstore/detail/leiga-recorder/fbnihbofaecfcmcedpcmiginclpcdmoh')
    };

  }
});
